import { render, staticRenderFns } from "./TableInfoBlock.vue?vue&type=template&id=27cc8010&scoped=true&"
import script from "./TableInfoBlock.vue?vue&type=script&lang=js&"
export * from "./TableInfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./TableInfoBlock.vue?vue&type=style&index=0&id=27cc8010&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cc8010",
  null
  
)

export default component.exports